import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibiré el material?',
  answer: 'Al instante. Una vez completado tu pago, recibirás un correo electrónico con acceso inmediato a todos los archivos en formato PDF, optimizados para leer en tu celular, tablet o computadora.'
}, {
  question: '¿Es seguro comprar desde mi país?',
  answer: 'Absolutamente. Utilizamos pasarelas de pago con cifrado SSL de nivel bancario. Tus datos están 100% protegidos y puedes pagar de forma segura desde cualquier lugar de Latinoamérica o España.'
}, {
  question: '¿Por qué el precio es de $6.39 USD?',
  answer: 'Nuestra misión es ayudar a la mujer hispana a romper el ciclo generacional de escasez. Queremos que el precio sea un puente, no un obstáculo, para que ninguna mujer se quede fuera de esta transformación.'
}, {
  question: '¿Necesito conocimientos previos de finanzas?',
  answer: 'No. Este no es un libro de contabilidad; es un manual de reprogramación mental y energética. Si sabes leer y tienes el deseo de cambiar tu realidad, tienes todo lo necesario.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí. No hay suscripciones, ni cargos mensuales, ni sorpresas. Un solo pago de $6.39 USD te da acceso de por vida al material y sus actualizaciones.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#FAF5E9]" data-id="element-12">
      <div className="max-w-3xl mx-auto px-6" data-id="element-13">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-stone-900 mb-12" data-id="element-14">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-stone-100 overflow-hidden" data-id="element-16">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-17">
                <span className="font-semibold text-stone-800 pr-4" data-id="element-18">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#C5A059] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-19" />
              </button>
              <AnimatePresence data-id="element-20">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-21">
                    <div className="px-6 pb-5 text-stone-600 leading-relaxed" data-id="element-22">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}